<template>
    <form class="register-form" @submit.prevent="formSubmit">
        <div class="form-group d-flex flex-wrap">
            <div class="register-form__gender mb-2 pr-sm-2">
                <input
                    id="male"
                    v-model="form.gender"
                    type="radio"
                    name="male"
                    value="m"
                    class="position-relative mr-1"
                />
                <label class="pr-2" for="male">De Heer</label>
                <input
                    id="female"
                    v-model="form.gender"
                    type="radio"
                    name="female"
                    value="f"
                    class="position-relative mr-1"
                />
                <label for="female">Mevrouw</label><br />
            </div>
            <div class="register-form__field mb-2 pr-sm-2">
                <label class="sr-only" for="name">Voornaam</label>
                <input
                    id="firstName"
                    v-model="form.firstName"
                    v-validate="'required'"
                    type="text"
                    class="form-control"
                    name="firstName"
                    placeholder="Voornaam *"
                    data-vv-as="Voornaam"
                />
                <span>{{ errors.first('firstName') }}</span>
            </div>
            <div class="register-form__field mb-2 pr-sm-2">
                <label class="sr-only" for="name">Achternaam</label>
                <input
                    id="lastName"
                    v-model="form.lastName"
                    v-validate="'required'"
                    type="text"
                    class="form-control"
                    name="lastName"
                    placeholder="Achternaam *"
                    data-vv-as="Achternaam"
                />
                <span>{{ errors.first('lastName') }}</span>
            </div>
            <div class="register-form__field mb-2 pr-sm-2">
                <label class="sr-only" for="email">E-mailadres</label>
                <input
                    id="email"
                    v-model="form.email"
                    v-validate="'required|email'"
                    type="email"
                    class="form-control"
                    name="email"
                    placeholder="E-mail *"
                    data-vv-as="E-mail"
                />
                <span>{{ errors.first('email') }}</span>
            </div>
            <div class="register-form__field mb-2 pr-sm-2">
                <label class="sr-only" for="phone">Telefoon</label>
                <input
                    id="phone"
                    v-model="form.phone"
                    type="tel"
                    class="form-control"
                    name="phone"
                    placeholder="Telefoon"
                />
            </div>
            <div class="register-form__field mb-2 pr-sm-2">
                <label class="sr-only" for="department">Afdeling</label>
                <input
                    id="department"
                    v-model="form.department"
                    type="text"
                    class="form-control"
                    name="department"
                    placeholder="Afdeling"
                />
            </div>
            <div class="register-form__field mb-2 pr-sm-2">
                <label class="sr-only" for="role">Functie</label>
                <input
                    id="role"
                    v-model="form.role"
                    type="text"
                    class="form-control"
                    name="role"
                    placeholder="Functie"
                />
            </div>
            <div class="register-form__field mb-2 pr-sm-2">
                <select
                    v-if="form.companies.length > 1"
                    v-model="form.selectedCompany"
                    class="form-control"
                >
                    <option
                        v-for="option in form.companies"
                        :key="option.id"
                        :value="option.id"
                    >
                        {{ option.name }}
                    </option>
                </select>
                <input
                    v-else-if="form.companies.length"
                    type="text"
                    class="form-control"
                    name="company"
                    disabled
                    :value="form.firstCompany"
                />
            </div>
            <div class="form-group row">
                <div class="col-12">
                    <vue-recaptcha
                        v-if="recaptcha"
                        ref="recaptcha"
                        size="invisible"
                        :sitekey="recaptcha"
                        @verify="postForm"
                    >
                    </vue-recaptcha>
                </div>
            </div>
            <div class="w-100">
                <p v-if="form.error" class="color--green float-left">
                    {{ form.error }}
                </p>
                <p v-if="form.success" class="color--green float-left">
                    {{ form.messages }}
                </p>
                <button
                    class="btn btn-primary mb-1 mr-sm-2 d-block d-sm-inline-block float-right"
                    :disabled="processing"
                    :class="{
                        disabled: form.success
                    }"
                    type="submit"
                >
                    Versturen
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import Axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';
export default {
    components: {
        'vue-recaptcha': VueRecaptcha
    },
    props: {
        firstName: {
            type: String,
            default: () => ''
        },
        lastName: {
            type: String,
            default: () => ''
        },
        email: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            form: {
                gender: 'm',
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phone: '',
                department: '',
                role: '',
                error: '',
                success: false,
                messages: '',
                companies: [],
                selectedCompany: '',
                firstCompany: ''
            },
            recaptcha: '',
            recaptchaToken: null,
            processing: false
        };
    },
    watch: {
        'form.email'() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.getCompanies();
            }, 1300);
        }
    },
    mounted() {
        this.recaptcha = document
            .getElementsByTagName('body')[0]
            .getAttribute('data-recaptcha-key');
    },
    created() {
        this.getCompanies();
    },
    methods: {
        getCompanies() {
            if (this.form.email != '') {
                const getUrl =
                    '/api/v1/domainApi/CompaniesByEmail?email=' +
                    this.form.email;
                Axios.get(getUrl).then(response => {
                    if (response.data != null && response.data.length > 0) {
                        this.form.companies = response.data;
                        this.form.selectedCompany = response.data[0].id;
                        this.form.firstCompany = response.data[0].name;
                    } else {
                        this.form.companies = [];
                        this.form.selectedCompany = '';
                        this.form.firstCompany = '';
                        this.formCompanyIsSet(true);
                    }
                });
            }
        },
        formCompanyIsSet(result) {
            if (result && this.form.selectedCompany == '') {
                this.errors.add({
                    field: 'email',
                    msg: 'U werkt voor een bedrijf dat geen lid is van de NVB'
                });
                return false;
            }
            return result;
        },
        formSubmit(e) {
            e.preventDefault;
            this.form.error = '';
            this.form.messages = '';
            this.$validator.validateAll().then(result => {
                if (this.formCompanyIsSet(result)) {
                    if (result) {
                        this.$refs.recaptcha.execute();
                    }
                }
            });
        },
        postForm(recaptchaToken) {
            this.recaptchaToken = recaptchaToken;
            this.processing = true;
            Axios.post('/api/v1/domainapi/registrate', {
                gender: this.form.gender,
                firstName: this.form.firstName,
                lastName: this.form.lastName,
                email: this.form.email,
                phonenumber: this.form.phone,
                department: this.form.department,
                role: this.form.role,
                company: this.form.selectedCompany,
                reCaptcha: this.recaptchaToken ?? recaptchaToken
            }).then(response => {
                this.processing = false;
                if (!response.data.success) {
                    this.form.error = Object.values(response.data.errors)[0];
                } else {
                    this.form.messages = Object.values(
                        response.data.messages
                    )[0];
                    this.form.success = true;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.register-form a {
    font-size: 0.875rem;
}

.register-form__field {
    width: 100%;

    @include media-breakpoint-up(sm) {
        width: 50%;
    }
}

.register-form__gender {
    width: 100%;
}

.register-form__gender label {
    cursor: pointer;
}

.register-form__gender input {
    width: 12px;
    height: 12px;
}

.register-form__gender input:after {
    content: '';
    width: 12px;
    height: 12px;
    background-color: $brand-gray;
    position: absolute;
    border-radius: 90px;
    top: 50%;
    transform: translateY(-50%);
}

.register-form__gender input:checked:after {
    background-color: $brand-blue;
}
</style>
